import { isA23 } from "@/src/colors/baseColors";
import styles from "../Stats.module.css";
import gameAssets from "@themed-assets";

export const StatsWelcome = ({ userName = '', joinTime = '' }) => {

  const brandColor = isA23 ? 'bg-accent' : 'bg-(--color-accent-muted)';

    return (
        <div className="flex justify-between items-center bg-header-bg pr-4">
          <div className={styles.welcomeWrapper}>
            <div className={styles.welcomeTitle}>Welcome {userName}</div>
            <div className={styles.playText}>
              <span className={styles.playText1}>Playing Since</span>
              <span className={`${styles.playText2} text-h-secondary`}> {joinTime}</span>
            </div>
          </div>
          <div className={`flex items-center justify-center ${brandColor} rounded-full p-3`}>
            <img className="opacity-100" src={gameAssets.rankGraph} alt="Rank Graph" />
          </div>
        </div>
    )
}
